import { isUndefined } from 'lodash-es';
import { useContext } from 'react';

import { TimeseriesChartAnnotationsConfigContext } from '../context/TimeseriesChartAnnotationsConfig.context.js';

export const useAnnotationsConfig = () => {
  const context = useContext(TimeseriesChartAnnotationsConfigContext);
  if (isUndefined(context)) {
    throw new Error(
      'useAnnotationsConfig must be used within a TimeseriesChartAnnotationsConfigContext',
    );
  }

  return context;
};
